import { createContext, useContext } from "react";

/* The autotrader status (/autotrade/status) is polled ONCE, by the app shell,
 * every 5 s — it feeds the top bar, the sidebar badge and the tab title. Screens
 * that also need it read it from here instead of running their own poll: the
 * Dashboard used to poll the same endpoint a second time, and each call prices
 * every open position with a broker quote. */
export const TraderStatusContext = createContext(null);

export const useTraderStatus = () => useContext(TraderStatusContext);
